
window.ATAC.siteFilter = (function (ATAC, atac_page_settings) {

    var customerFilterSiteDelegates = [];
    var user = { roles: [] };

    var cdnURL = 'ENV.portal:CDN_URL';
    var selectedCorporateSites = [];
    var api = new ApiCalls(cdnURL);

    var map;
    var googleMapMarkers = [];
    var stateView = true;

    var publicProperties = {
        initialize: function (callback) {
            scaffoldCustomerSiteFilter();

            if (callback) {

                registerCustomerFilterSiteDelegates(callback);
            }

            if (atac_page_settings.showDropdownFilterBox && atac_page_settings.showSiteFilterBox) {
                init();
            }
        },
        getCustomerFilterSiteDelegates: function () {
            return customerFilterSiteDelegates;
        },
        registerCustomerFilterSiteDelegates: registerCustomerFilterSiteDelegates,
        selectedSites: [],
        api: api,
        onSitesLoadingCallback: undefined
    };

    return publicProperties;
    
    /*Public Methods*/
    function isLoading(state) {
        if (publicProperties.onSitesLoadingCallback) {
            publicProperties.onSitesLoadingCallback(state);
        }
    }

    function registerCustomerFilterSiteDelegates(callback) {
        customerFilterSiteDelegates.push(callback);
    }

    function init() {
        $('#atac_user_corporate_sites_dropdown_holder').select2({
            placeholder: "Loading...",
            theme: "autocar"
        });
        showLoader();
        loadMap()
        .then(function () {
            getUserDetails();
        });
    }

    // dom ready
    function loadMap() {



        if (window.google && google.maps) {
            return initializeMap();
        } else {
            lazyLoadGoogleMap();
        }

    };

    function initializeGoogleMap() {



        var myLatlng = new google.maps.LatLng(40, -100);

        var mapOptions = {
            zoom: 4,
            center: myLatlng,
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            fullscreenControl: false,
            rotateControl: false,
            draggable: true,
            disableDefaultUI: true,
            scrollwheel: true,
            disableDoubleClickZoom: true,
            minZoom: 4,
            styles: [
                {
                    'featureType': 'all',
                    'elementType': 'labels.text.fill',
                    'stylers': [{ 'saturation': 36 }, { 'color': '#000000' }, { 'lightness': 40 }]
                },
                {
                    'featureType': 'all',
                    'elementType': 'labels.text.stroke',
                    'stylers': [{ 'visibility': 'on' }, { 'color': '#000000' }, { 'lightness': 16 }]
                }, {
                    'featureType': 'all',
                    'elementType': 'labels.icon',
                    'stylers': [{ 'visibility': 'off' }]
                }, {
                    'featureType': 'administrative',
                    'elementType': 'geometry.fill',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 20 }]
                }, {
                    'featureType': 'administrative',
                    'elementType': 'geometry.stroke',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 17 }, { 'weight': 1.2 }]
                }, {
                    'featureType': 'landscape',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 20 }]
                }, {
                    'featureType': 'poi',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 21 }]
                }, {
                    'featureType': 'road.highway',
                    'elementType': 'geometry.fill',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 17 }]
                }, {
                    'featureType': 'road.highway',
                    'elementType': 'geometry.stroke',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 29 }, { 'weight': 0.2 }]
                }, {
                    'featureType': 'road.arterial',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 18 }]
                }, {
                    'featureType': 'road.local',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 16 }]
                }, {
                    'featureType': 'transit',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 19 }]
                }, {
                    'featureType': 'water',
                    'elementType': 'geometry',
                    'stylers': [{ 'color': '#000000' }, { 'lightness': 17 }]
                }
            ]
        };

        map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

        return api.getUsaStateGeoCode()
            .then(function (result) {
                var geojson = topojson.feature(result, result.objects.collection);
                map.data.addGeoJson(geojson, { idPropertyName: 'STATEID' });
                 map.data.setStyle(styleFeature);
                 map.data.addListener('click',
                     function (e) {
                         var state = e.feature.getProperty('NAME');
                         var stateId = e.feature.getProperty('STATEID');
                         if (e.feature.getProperty('CLICKABLE')) {
                             if (checkSelectedMarkersWithinAState(stateId) === 0 || stateView) {
                                 setDisplayOfAllMarkersWithinState(stateId, !e.feature.getProperty('selected'));
                                 getSiteIds();
                             }
                         }
                     });

                 function styleFeature(feature) {
                     var outlineWeight = 0.5;
                     var zIndex = 2;
                     var fillColor = '#333';
                     var fillOpacity = 0.1;
                     var activeOpacity = 0.5;
                     var activeColor = '#54B95A';
                     var strokeColor = '#fff';
                     var strokeWeight = outlineWeight;

                     if (feature.getProperty('CLICKABLE') === false) {
                         fillOpacity = 0.25;
                         fillColor = '#FFF';
                     }

                     if (feature.getProperty('selected')) {
                         fillColor = activeColor;
                         fillOpacity = activeOpacity;
                     }

                     return {
                         strokeWeight: strokeWeight,
                         strokeColor: strokeColor,
                         zIndex: zIndex,
                         fillColor: fillColor,
                         fillOpacity: fillOpacity
                     };
                 }
             });
    }

    function lazyLoadGoogleMap() {
        return $.getScript("http://maps.google.com/maps/api/js?sensor=true&callback=initializeMap")
         .then(function (script, textStatus) {
         })
         .fail(function (jqxhr, settings, ex) {
         });
    }

    function initializeMap() {
        return initializeGoogleMap();
    }

    function redrawMap() {

        google.maps.event.trigger(map, 'resize');
        map.setCenter(new google.maps.LatLng(40, -100));
    }

    function setSiteFilterDisplay() {

        if (isInRole('SSO:Autocar')) {
            api.getCorporates()
                .done(function (corporates) {
                    populateCorporatesDropdown(corporates);
                });
            $('#CorporateSearchddl').show();
        } else {
            hideAll();
            api.getUserCorporate()
                 .done(function (corporate) {
                     populateUserSpecificCorporate(corporate);
                 });
        }

        function populateCorporatesDropdown(corporates) {
            var $atacUserCorporateSitesDropdownHolder = $('#atac_user_corporate_sites_dropdown_holder').html('');
            var firstLoop = true;
            $atacUserCorporateSitesDropdownHolder.on('select2:select', function (e) {
                showLoader();
                setCorporateRegionsAreasAndSites($(this).select2('data')[0]);
            });
            _.each(corporates, function (corporate) {
                corporate.id = corporate.CustomerId;
                corporate.text = corporate.CustomerName;
                if (firstLoop) {
                    setCorporateCustomerDetails(corporate);
                    setCorporateRegionsAreasAndSites(corporate);
                    firstLoop = false;
                }
            });
            $atacUserCorporateSitesDropdownHolder.select2({ data: corporates, theme: 'autocar' });

            function setCorporateRegionsAreasAndSites(corporate) {

                $('#siteFilterContentReturned').show();
                $('#siteFilterNoContentReturned').hide();

                isLoading(true);

                api.getRegionsAndAreas(corporate)
                .done(
                  function (data) {
                      corporate.Regions = data.Regions;
                      corporate.Areas = data.Areas;
                      bindDropdowns(corporate);
                      populateRegionsWithSites(corporate);
                      executeCustomerFilterSiteDelegates();
                      setCorporateCustomerDetails(corporate.CustomerName);
                      isLoading(false);
                  }
              ).fail(
                  function (fail) {
                      $('#siteFilterContentReturned').hide();
                      $('#siteFilterNoContentReturned').show();
                      executeCustomerFilterSiteDelegates();
                      setCorporateCustomerDetails(corporate.CustomerName);
                      throw fail;
                  }
              );

                api.getCorporateSites(corporate)
                    .done(function(data) {
                        corporate.StatesWithSites = data;
                        isLoading(false);
                    });
            }
        }

        function populateUserSpecificCorporate(corporate) {
            setCorporateCustomerDetails(corporate.CustomerName);

            if (isInRole('SSO:Corporate')) {
                showSiteFilterBoxToggle();
                api.getCorporateSites(corporate)
                    .done(function (data) { corporate.StatesWithSites = data; });
                bindDropdowns(corporate);
                populateRegionsWithSites(corporate);
            } else if (isInRole('SSO:Region')) {
                showSiteFilterBoxToggle();
                //hideRegionAreaDropDown();
                populateRegionsWithSites(corporate);
            } else if (isInRole('SSO:Area')) {
                showSiteFilterBoxToggle();
                //hideRegionAreaDropDown();
                populateAreasWithSites(corporate);
            } else if (isInRole('SSO:Site')) {
                corporate.Site.selected = true;
                selectedCorporateSites.push(corporate.Site);
                getSiteIds();
                destroyAll();
            }

            executeCustomerFilterSiteDelegates();
        }

        function setCorporateCustomerDetails(corporateName) {

            $('#lbcorporateCustomerName').html(corporateName);
        }

        function populateRegionsWithSites(corporate) {
            populateRegionsAreas(corporate.Regions, 'Regions');
        }

        function populateAreasWithSites(corporate) {
            populateRegionsAreas(corporate.Areas, 'Areas');
        }

        function populateStatesWithSites(corporate) {
            populateRegionsAreas(corporate.StatesWithSites, 'Sites');
        }

        function populateRegionsAreas(data, type) {
            $('#regionAreaSiteDropdownItem').html(type + ' <span class="caret"></span>');

            resetContentforNoContentReturned();

            if ((isInRole('SSO:Autocar') || isInRole('SSO:Corporate')))
                showHideRegionAreaSelect(type);

            if (type === 'Sites') {
                if (data.length > 0) {
                    populateSites(data);
                } else {
                    sitesReturnedNoContent();
                }

            } else {

                var $atacRegionAreaDropdownHolder = $('#atac_region_area_dropdown_holder').html('');
                var firstLoop = true;

                if (data.length > 0) {
                    _.each(data,
                    function (regionArea) {
                        buildAtacRegionAreaDropdownHolder($atacRegionAreaDropdownHolder, regionArea);
                        if (firstLoop) {
                            defaultSelection($atacRegionAreaDropdownHolder, regionArea);
                            firstLoop = false;
                            populateSites(regionArea.StatesWithSites);
                        }
                    });
                } else {
                    regionsAreasReturnedNoContent();
                }
            }

            function buildAtacRegionAreaDropdownHolder($atacRegionAreaDropdownHolder, regionArea) {
                var regionAreasDropdownControl = $(ATAC.htmlFactory.GetHTMLByTemplateName('regions_areas_dropdown', { id: regionArea.RegionId || regionArea.AreaId, name: regionArea.RegionName || regionArea.AreaName }));
                regionAreasDropdownControl.click(function () {
                    resetContentforNoContentReturned();
                    $('#regionsAreasDropdownItem').html((regionArea.RegionName || regionArea.AreaName) + ' <span class="caret"></span>');
                    populateSites(regionArea.StatesWithSites);
                });
                $atacRegionAreaDropdownHolder.append(regionAreasDropdownControl);

            }

            function populateSites(states) {
                selectedCorporateSites = [];
                clearGoogleMapSeletedSates();
                clearGoogleMapMarkers();
                if (states.length > 0) {
                    var $atacCorporateSitesHolder = $('#atac_corporate_sites_holder').html('');
                    var $atacCorporateStatesHolder = $('#atac_corporate_States_holder').html('');
                    var $stateBarHoldler = buildAtacStateBarHoldler();
                    var columnPointer = 0;
                    _.each(states,
                        function (state) {
                            var feature = createGoogleMapSelectedSate(state.StateId);
                            var $stateItemsHoldler = buildAtacStateItemsHoldler(state);
                            state.dataToggleId = state.StateName.replace(" ", "");
                            $atacCorporateSitesHolder.append(buildAtacCorporateState(state));
                            var $stateHoldler = buildAtacStateHolder(state);
                            var $siteHolder = buildAtacSiteHolder();
                            _.each(state.Sites,
                                function (site) {
                                    if (typeof (feature) != "undefined") {
                                        site.selected = true;
                                        selectedCorporateSites.push(site);
                                        columnPointer = (columnPointer === 2) ? 0 : columnPointer + 1;
                                        $siteHolder.append(buildAtacCorporateSite(site));
                                        createGoogleMapMarkers(site, map, feature);
                                    }
                                });
                            $stateBarHoldler.append($stateItemsHoldler);
                            $stateHoldler.append($siteHolder);
                            $atacCorporateStatesHolder.append($stateBarHoldler);
                            $atacCorporateSitesHolder.append($stateHoldler);
                        });
                } else { sitesReturnedNoContent(); }

                hideLoader();
                getSiteIds();

                function buildAtacStateHolder(state) {
                    var stateHolder = $(ATAC.htmlFactory.GetHTMLByTemplateName("state_header", state));
                    return stateHolder;
                };

                function buildAtacSiteHolder() {
                    var siteHolder = $(ATAC.htmlFactory.GetHTMLByTemplateName('site_container_ul'));
                    return siteHolder;
                };

                function buildAtacCorporateSite(site) {
                    var corporateSitesComboboxControl = $(ATAC.htmlFactory.GetHTMLByTemplateName('corporate_site', site));
                    corporateSitesComboboxControl.find('input[type=checkbox]').click(function () {

                        site.selected = !site.selected;

                        var marker;
                        _.each(googleMapMarkers, function (googleMapMarker) {
                            if (googleMapMarker.id === site.CustomerId) {
                                marker = googleMapMarker;
                                var feature = map.data.getFeatureById(site.State.StateId);
                                updateMarker(marker, site, feature);
                            }
                        });

                        getSiteIds();
                    });
                    return corporateSitesComboboxControl;
                }

                function buildAtacCorporateState(state) {


                    var feature = map.data.getFeatureById(state.StateId);
                    if (typeof (feature) != "undefined") {
                        var corporateStateComboboxControl = $(ATAC.htmlFactory.GetHTMLByTemplateName('corporate_state', state));
                        corporateStateComboboxControl.find('input[type=checkbox]').click(function () {
                            var stateId = ($(this).val() !== 'undefined') ? parseInt($(this).val()) : 0;
                            var feature = map.data.getFeatureById(stateId);
                            setDisplayOfAllMarkersWithinState(stateId, !feature.getProperty('selected'));
                            getSiteIds();
                        });
                        return corporateStateComboboxControl;
                    }
                }

                function buildAtacStateBarHoldler() {
                    var stateBarHoldler = $(ATAC.htmlFactory.GetHTMLByTemplateName('state_bar_ul'));
                    return stateBarHoldler;
                };

                function buildAtacStateItemsHoldler(state) {

                    var feature = map.data.getFeatureById(state.StateId);
                    if (typeof (feature) != "undefined") {
                        var stateItemContainer = $(ATAC.htmlFactory.GetHTMLByTemplateName('state_Item_container', state));
                        stateItemContainer.find('a').click(function () {
                            var stateId = ($(this).attr('value') !== 'undefined') ? parseInt($(this).attr('value')) : 0;
                            var feature = map.data.getFeatureById(stateId);
                            setDisplayOfAllMarkersWithinState(stateId, !feature.getProperty('selected'));
                            getSiteIds();
                        });
                        return stateItemContainer;
                    }
                };
            }

            function resetContentforNoContentReturned() {

                $('#SiteSelectContentReturned').show();
                $('#SiteSelectNoContentReturned').hide();
                $('#regionsAreasDropdownMain').css('display', 'inline-block');
                $('#SiteSelectContentReturned').show();
                $('#SiteSelectNoContentReturned').hide();
            }

            function sitesReturnedNoContent() {
                $('#SiteSelectContentReturned').hide();
                $('#SiteSelectNoContentReturned').show();
            }

            function regionsAreasReturnedNoContent() {
                selectedCorporateSites = [];
                executeCustomerFilterSiteDelegates();
                hideLoader();

                $('#regionsAreasDropdownMain').attr('style', 'display: none !important');
                $('#SiteSelectContentReturned').hide();
                $('#SiteSelectNoContentReturned').show();
            }

            function showHideRegionAreaSelect(type) {
                if (type === 'Sites') {
                    $('#regionsAreasDropdownMain').attr('style', 'display: none !important');
                }
                else {
                    $('#regionsAreasDropdownMain').css('display', 'inline-block');
                }
            }

            function defaultSelection($atacRegionAreaDropdownHolder, regionArea) {
                $('#regionsAreasDropdownItem').html((regionArea.RegionName || regionArea.AreaName) + ' <span class="caret"></span>');
            }


        }

        function bindDropdowns(corporate) {
            $('#regionAreaDropdown li').on('click', 'a', function () {
                var type = $(this).text();
                $(this).parents('.btn-group').find('.dropdown-toggle').html(type + ' <span class="caret"></span>');
                switch (type) {
                    case 'Regions':
                        populateRegionsWithSites(corporate);
                        break;
                    case 'Areas':
                        populateAreasWithSites(corporate);
                        break;
                    case 'Sites':
                        populateStatesWithSites(corporate);
                        break;
                    default:
                }
            });
        }
    }

    /*Private Methods*/
    function scaffoldCustomerSiteFilter() {

        if ($('#atac_dropdown_filter_box').length > 0) {
            atac_page_settings.showDropdownFilterBox = true;
            $('#atac_dropdown_filter_box').append(ATAC.htmlFactory.GetHTMLByTemplateName('dropdown_filter_box_widget', application_metadata));
        }

        if ($('#atac_site_filter_box').length > 0) {
            atac_page_settings.showSiteFilterBox = true;
            $('#atac_site_filter_box').append(ATAC.htmlFactory.GetHTMLByTemplateName('site_filter_box_widget', application_metadata));
        }

        $('#btnCustomerSiteSelectAll').on('click', selectAllSites);

        $('#btnCustomerSiteDeselectAll').on('click', deselectAllSites);

        $('#btnCustomerSiteFilter').on('click', getSiteIds);

        $('#siteFilterBox').on('hidden.bs.collapse',
            function (e) {
                if ($(this).is(e.target)) {
                    executeCustomerFilterSiteDelegates();
                }
            });

        $('#siteFilterBox').on('shown.bs.collapse', redrawMap);

        $('#StateSiteView').on('click', function () {

            stateView = $(this).is(":checked");
            setGoogleMapMarkerState();
        });



        $("#corporateSearchFilter").keyup(function () {

            if ($(this).val().length > 0) {

                $(".SearchItems").hide();

                var filter = $(this).val(), count = 1;

                $(".SearchItems").each(function () {

                    var collapseContainer = $(this).parents('.list-group');

                    collapseContainer.removeClass('collapse').addClass('in collapse');
                    collapseContainer.height('auto');
                    collapseContainer.height('');

                    var toplevel = $(this);

                    $(this).find(".lblcustomerSite").each(function () {

                        if ($(this).text().search(new RegExp(filter, "i")) < 0) {

                            $(this).hide();

                        } else {

                            $(toplevel).show();

                            $(this).show();

                            count++;
                        }
                    });
                });
            } else {
                $(".SearchItems").show();
                $(".SearchItems")
                    .each(function () {
                        var collapseContainer = $(this).parents('.list-group');
                        collapseContainer.removeClass('in collapse').addClass('collapse');
                    });
            }

        });


        function selectAllSites() {
            setActivetSites(true);
        }

        function deselectAllSites() {
            setActivetSites(false);
        }

        function setActivetSites(flag) {
            $('#atac_corporate_sites_holder').find('input[type=checkbox]').prop('checked', flag);
            var stateIds = [];
            _.each(selectedCorporateSites, function (item) {
                if ($.inArray(item.State.StateId, stateIds) === -1) {
                    stateIds.push(item.State.StateId);
                    setDisplayOfAllMarkersWithinState(item.State.StateId, flag);
                }
            });
            getSiteIds();
        }
    }

    function clearGoogleMapSeletedSates() {

        map.data.forEach(function (feature) {
            feature.setProperty('selected', false);
            feature.setProperty('CLICKABLE', false);
        });
    }

    function createGoogleMapSelectedSate(stateId) {

        var feature = map.data.getFeatureById(stateId);
        if (typeof (feature) != "undefined") {
            feature.setProperty('selected', true);
            feature.setProperty('CLICKABLE', true);
        };
        return feature;
    };

    function clearGoogleMapMarkers() {

        _.each(googleMapMarkers, function (marker) {
            marker.setMap(null);
        });

        googleMapMarkers = [];
    }

    function setGoogleMapMarkerState() {

        _.each(googleMapMarkers, function (marker) {
            if (stateView) {
                marker.setVisible(false);
            } else {
                var feature = map.data.getFeatureById(marker.stateid);
                if (typeof (feature) != "undefined") {
                    if (feature.getProperty('selected')) {
                        marker.setVisible(true);
                    }
                }
            }
        });
    }

    function setDisplayOfAllMarkersWithinState(stateId, flag) {

        var feature = map.data.getFeatureById(stateId);

        if (feature.getProperty('selected') !== flag) {

            feature.setProperty('selected', flag);
            $("#" + stateId.toString()).prop('checked', flag);
            $("i." + stateId).toggleClass("fa-check fa-times");
            $("i." + stateId).toggleClass("statebarListItemSelected statebarListItemUnSelected");

            _.each(googleMapMarkers, function (googleMapMarker) {
                if (googleMapMarker.stateid === stateId) {

                    if (!stateView) { googleMapMarker.setVisible(flag); }
                    googleMapMarker.setIcon(flag ? googleMapMarker.ActiveTruckIconUrl : googleMapMarker.InactiveTruckIconUrl);
                    googleMapMarker.selected = flag;

                    _.each(selectedCorporateSites, function (item) {
                        if (item.CustomerId === googleMapMarker.id) {
                            $("#Site_" + item.CustomerId).prop('checked', flag);
                            item.selected = flag;
                        }
                    });
                }
            });
        }
    }

    function createGoogleMapMarkers(site, map, feature) {

        var myLatlng = new google.maps.LatLng(site.Latitude, site.Longitude);
        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: site.CustomerName,
            id: site.CustomerId,
            visible: !stateView,
            selected: site.selected,
            stateid: site.State.StateId,
            ActiveTruckIconUrl: cdnURL + site.ActiveTruckIconUrl,
            InactiveTruckIconUrl: cdnURL + site.InactiveTruckIconUrl
        });

        googleMapMarkers.push(marker);
        markerClickEvent(marker, site, feature);
        marker.setIcon(marker.ActiveTruckIconUrl);
    }

    function markerClickEvent(marker, site, feature) {
        marker.addListener('click', function (e) {
            updateMarker(marker, site, feature);
            getSiteIds();
        });
    };

    function updateMarker(marker, site, feature) {

        var stateId = feature.getProperty('STATEID');
        var siteSelectedState = !marker.selected;
        marker.selected = siteSelectedState;
        site.selected = siteSelectedState;
        $("#Site_" + site.CustomerId).prop('checked', siteSelectedState);
        marker.setIcon(siteSelectedState ? marker.ActiveTruckIconUrl : marker.InactiveTruckIconUrl);
        if (checkSelectedMarkersWithinAState(stateId) === 0) {
            setDisplayOfAllMarkersWithinState(stateId, false);
        } else {
            if (!feature.getProperty('selected')) {
                feature.setProperty('selected', true);
                $("#" + stateId).prop('checked', true);
                setGoogleMapMarkerState();
                $("i." + stateId).toggleClass("fa-check fa-times");
                $("i." + stateId).toggleClass("statebarListItemSelected statebarListItemUnSelected");
            }
        }
    };

    function checkSelectedMarkersWithinAState(stateId) {

        var selectedCount = 0;
        _.each(googleMapMarkers, function (googleMapMarker) {
            if (googleMapMarker.stateid === stateId) {
                if (googleMapMarker.selected) {
                    selectedCount++;
                };
            }
        });

        return selectedCount;
    }

    function executeCustomerFilterSiteDelegates() {
        var siteIds = getSiteIds();
        if (customerFilterSiteDelegates.length > 0) {
            _.each(customerFilterSiteDelegates,
                function (callback) {
                    if (typeof callback === 'function') {
                        callback(siteIds);
                    }
                });
        }
    }

    function getSiteIds() {
        ATAC.siteFilter.selectedSites = selectedCorporateSites.filter(function (site) {
            return !!site.selected;
        }).map(function (site) {
            return site.CustomerId;
        });
        return ATAC.siteFilter.selectedSites;
    }

    function getUserDetails() {
        if (!!atac_page_settings.security.bearerToken()) {
            user = jwt_decode(atac_page_settings.security.bearerToken());
        };
        setSiteFilterDisplay();
    }

    function showLoader() {

        $('#regionAreaFilterLoader').show();
        $('#corporateSiteLoader').show();

        $('#atac_corporate_sites_holder1').html('');
        $('#atac_corporate_sites_holder2').html('');
        $('#atac_corporate_sites_holder3').html('');

        $('#btnFilter').attr('disabled', 'disabled');
        $('#regionAreaSiteDropdownItem').attr('disabled', 'disabled');
        $('#regionsAreasDropdownItem').attr('disabled', 'disabled');
        $('#btnSelectAll').attr('disabled', 'disabled');
        $('#btnDeselectAll').attr('disabled', 'disabled');
    }

    function hideLoader() {

        $('#regionAreaFilterLoader').hide();
        $('#corporateSiteLoader').hide();

        $('#btnFilter').removeAttr('disabled');
        $('#regionAreaSiteDropdownItem').removeAttr('disabled');
        $('#regionsAreasDropdownItem').removeAttr('disabled');
        $('#btnSelectAll').removeAttr('disabled');
        $('#btnDeselectAll').removeAttr('disabled');
    }

    function hideAll() {
        $('#atac_dropdown_filter_box').hide();
        $('#atac_site_filter_box').hide();
    }

    function destroyAll() {
        $('#atac_dropdown_filter_box').html('');
        $('#atac_site_filter_box').html('');
    }

    function showSiteFilterBoxToggle() {

        $('#atac_site_filter_box').show();
        $('#atac_dropdown_filter_box').show();
        $('#siteFilterBoxToggle').show();
    }

    function isInRole(role) {
        return $.inArray(role, user.roles) > -1;
    }

    function ApiCalls(cdnURL) {
        var apiURL = 'ENV.portal:API_URL';

        var service = {
            getCorporates: getCorporates,
            getUserCorporate: getUserCorporate,
            getRegionsAndAreas: getRegionsAndAreas,
            getCorporateSites: getCorporateSites,
            getUsaStateGeoCode: getUsaStateGeoCode
        };

        function getCorporates() {
            return $.ajax({
                type: 'GET',
                url: apiURL + '/api/Corporate/TopLevel',
                data: '',
                dataType: ''
            }).fail(getRequestError);;
        };

        function getUserCorporate() {
            return $.ajax({
                type: 'GET',
                url: apiURL + '/api/Corporate/User',
                data: '',
                dataType: ''
            }).fail(getRequestError);
        }

        function getRegionsAndAreas(corporate) {
            return $.ajax({
                type: 'GET',
                url: apiURL + '/api/Corporate/' + corporate.CustomerId,
                data: '',
                dataType: ''
            });
        }

        function getCorporateSites(corporate) {
            return $.ajax({
                type: 'GET',
                url: apiURL + '/api/Corporate/' + corporate.CustomerId + '/StatesWithSites',
                data: '',
                dataType: ''
            }).fail(function (fail) { throw fail; });
        }

        function getRequestError(fail) {
            destroyAll();
            executeCustomerFilterSiteDelegates();
            throw fail;
        }

        function getUsaStateGeoCode() {
            return $.ajax({
                type: 'GET',
                url: cdnURL + '/json/map-min.json',
                dataType: "json",
                contentType: "application/json"
            })
            .done(function () { })
            .fail(getRequestError);;
        };

        return service;
    };




})(window.ATAC, atac_page_settings);


window.ATAC.siteFilter.initialize();

